<mat-form-field class="full-width">
    <mat-label>{{config.label ? config.label : config.name}}</mat-label>
    <mat-select [formControl]="formControl">
        @for(opt of config.options; track $index){
        <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
    </mat-select>
</mat-form-field>